import WeaveUi from './weave-ui';

export default class Combobox extends WeaveUi {

    constructor() {
        super();
        this.$elements = {
            header: $('<span class="weave-widget weave-combobox weave-header"></span>'),
            dropdownWrap: $('<span class="weave-dropdown-wrap weave-state-default"></span>'),
            input: $('<input name="" class="weave-input" type="text" placeholder="" autocomplete="off"/>'),
            icon: $('<span unselectable="on" class="weave-icon weave-icon-close title="clear"></span>'),
            select: $('<span unselectable="on" class="weave-select"><span class="weave-icon weave-i-arrow-s"></span>')
        };

        this.$dataElements = {
            animationContainer: $('<div class="weave-animation-container"></div>'),
            listContainer: $('<div class="weave-list-container weave-popup weave-group weave-reset"></div>'),
            listScroller: $('<div class="weave-list-scroller"></div>'),
            list: $('<ul unselectable="on" class="weave-list weave-reset"></ul>'),
            listItem: $('<li unselectable="on" class="weave-item"></li>'),
            listItemContainer: $('<span class="custom-items"></span>'),
            groupHeader: $('<div class="weave-group-header style"display:none"/>')
        };
        this.$selects = $('select');
        var that = this;
        this.$selects.each(function() {
            let $this = $(this);
            let $newCombobox = that.$elements.header.clone();
            $this.hide();
            that.buildCombobox($this, $newCombobox);
        });

    }

    buildCombobox($this, $newCombobox) {
        var $thisClone = $this.clone();
        $this.replaceWith($newCombobox);
        $newCombobox.append(this.$elements.dropdownWrap.clone());
        this.$elements.input.attr('name', 'input-' + $this.attr('name'));
        this.$elements.input.attr('placeholder', $this.attr('placeholder'));
        $newCombobox.find('.weave-dropdown-wrap').append(this.$elements.input.clone());
        $newCombobox.find('.weave-dropdown-wrap').append(this.$elements.icon.clone());
        $newCombobox.find('.weave-dropdown-wrap').append(this.$elements.select.clone());
        $newCombobox.find('.weave-dropdown-wrap').append($thisClone);
        $newCombobox.attr('data-id', super.randomString(32));
        this.buildComboboxData($this, $newCombobox);
        this.comboboxEvents();
    }

    buildComboboxData($this, $newCombobox) {
        "use strict";
        var $dataContainer = this.$dataElements.animationContainer.clone();
        $dataContainer.attr('data-id', $newCombobox.attr('data-id'));
        var $options = $this.find('option:not([data-weave-ui-ignore="true"])');
        $dataContainer.append(this.$dataElements.listContainer.clone());
        $dataContainer.find('.weave-list-container').append(this.$dataElements.groupHeader.clone()).append(this.$dataElements.listScroller.clone()).find('.weave-list-scroller').append(this.$dataElements.list.clone());
        var $weaveListContainer = $dataContainer.find('.weave-list');
        var position = $newCombobox.offset();
        $dataContainer.css('top', position.top + 32);
        $dataContainer.css('left', position.left);
        $('body').append($dataContainer);
        var that = this;
        $options.each(function() {
            var $this = $(this);
            var $newItem = that.$dataElements.listItem.clone();
            var $newItemContainer = that.$dataElements.listItemContainer.clone();
            $newItem.attr('data-value', $this.attr('value'));
            var spans = $this.attr('data-spans').split('|');
            $newItem.append($newItemContainer);
            $newItem.attr('data-text', $this.data('text'));
            for (var i = 0; i < spans.length; i++) {
                $newItemContainer.append('<span>' + spans[i] + '</span>');
            }
            $weaveListContainer.append($newItem);
        });
    }

    hideListContainer($listContainer) {
        "use strict";
        $listContainer.parent().css('overflow', 'hidden');
        $listContainer.parent().css('display', 'none');
        $listContainer.css('display', 'none');
        $listContainer.css('transform', 'translateY(-53px)');
        $listContainer.css('transition', 'all 200ms ease-out');
        $listContainer.css('transition', '');
        $('.weave-combobox[data-id="' + $listContainer.closest('.weave-animation-container').attr('data-id') + '"]').find('.weave-dropdown-wrap').removeClass('icon-clicked');
    }

    hideAllListContainer() {
        "use strict";
        var $listContainer = $('.weave-animation-container').find('.weave-list-container');
        $listContainer.each(function() {
            var $this = $(this);
            $this.parent().css('overflow', 'hidden');
            $this.parent().css('display', 'none');
            $this.css('display', 'none');
            $this.css('transform', 'translateY(-53px)');
            $this.css('transition', 'all 200ms ease-out');
            $this.css('transition', '');
            $('.weave-combobox[data-id="' + $this.closest('.weave-animation-container').attr('data-id') + '"]').find('.weave-dropdown-wrap').removeClass('icon-clicked');
        });
    }

    showListContainer($listContainer) {
        "use strict";
        $listContainer.parent().css('overflow', 'visible');
        $listContainer.parent().css('display', 'block');
        $listContainer.css('display', 'block');
        $listContainer.css('transform', 'translateY(0px)');
        $listContainer.css('transition', 'all 200ms ease-out');
        $listContainer.css('transition', '');
        $('.weave-combobox[data-id="' + $listContainer.closest('.weave-animation-container').attr('data-id') + '"]').find('.weave-dropdown-wrap').addClass('icon-clicked');
    }

    comboboxEvents() {
        "use strict";
        var that = this;
        $('.weave-combobox .weave-input,.weave-combobox .weave-select, html').click(function(e) {
            e.stopImmediatePropagation();
            var visible = false;
            var $this = $(this);
            var $that = $('.weave-animation-container[data-id="' + $this.closest('.weave-combobox').attr('data-id') + '"]').find('.weave-list-container');
            if ($that.is(':visible')) {
                visible = true;
            }
            that.hideAllListContainer();
            if ($(e.target).attr('class') !== 'weave-input' && $(e.target).attr('class') !== 'weave-select' && $(e.target).attr('class') !== 'weave-icon weave-i-arrow-s') {
                $this = $('.weave-dropdown-wrap.icon-clicked').find('.weave-input');
            }
            if (visible) {
                that.hideListContainer($that);
            } else {
                that.showListContainer($that);
            }
        });

        $('.weave-item').click(function(e) {
            var $this = $(this);
            var $that = $('.weave-combobox[data-id="' + $this.closest('.weave-animation-container').attr('data-id') + '"]');
            e.stopImmediatePropagation();
            $that.find('input').val($this.attr('data-text'));
            that.hideListContainer($this.closest('.weave-list-container'));
            $that.find('option').removeAttr('selected');
            $that.find('option[value="' + $this.attr('data-value') + '"]').attr('selected', 'selected');
        });

        $('.weave-input').keyup(function() {
            var $this = $(this);
            var val = $this.val();
            var $list = $('.weave-animation-container[data-id="' + $this.closest('.weave-combobox').attr('data-id') + '"]');
            var $lis = $list.find('li');
            $this.closest('.weave-combobox').find('select option[data-text="' + $this.val() + '"]').attr('selected','selected');
            if (val.length < 3) {
                $lis.removeClass('hidden');
                return;
            }
            $lis.each(function() {
                var $this = $(this);
                if ($this.html().toLowerCase().indexOf(val.toLowerCase()) === -1) {
                    $this.addClass('hidden');
                }
            });
        });

        $(document).on('rebuild-comboboxs',function(e,$selects){
            $selects.each(function() {
                let $this = $(this);
                let $newCombobox = that.$elements.header.clone();
                $this.hide();
                that.buildCombobox($this, $newCombobox);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./js/weave-ui/combobox.js